<template>
  <Page subpage>
    <div class="flex justify-between items-center mb-4">
      <h3 class="page-header-2">Progress Billing</h3>
    </div>
    <ProgressBillingConfig :schedules="schedules" />
    <div class="mt-4">
      <ProgressBillingSchedulesList
        :schedules="schedules"
        :loading="loading"
        @reload="loadSchedules"
      />
    </div>
  </Page>
</template>

<script setup lang="ts">
import { onMounted, ref } from "vue";
import { useStore } from "vuex";

import Page from "@/components/Page.vue";
import ProgressBillingConfig from "./ProgressBillingConfig.vue";
import ProgressBillingSchedulesList from "./ProgressBillingSchedulesList.vue";

interface Installment {
  id: number;
  label: string;
  percentage: number;
  position: number;
}

interface Schedule {
  id: number;
  name: string;
  description?: string;
  is_active: boolean;
  system_default: boolean;
  installments: Installment[];
}

const store = useStore();

const loading = ref(true);
const schedules = ref<Schedule[]>([]);

async function loadSchedules() {
  loading.value = true;
  // Config fetch must complete first — Config.for() seeds system schedules
  // on first access, so schedules won't exist until the config is created.
  await store.dispatch("fetchProgressBillingConfig");
  schedules.value = await store.dispatch("fetchProgressBillingSchedules");
  loading.value = false;
}

onMounted(loadSchedules);
</script>
